export default __webpack_public_path__ + "static/media/students.2c6546ce.jpg";